<template>
  <gmap-autocomplete class="form-control"
                     :id="field.name"
                     :name="field.name"
                     :readonly="locked"
                     :value="value"
                     :data-vv-as="field.description.replace(/\./g, '')"
                     v-validate="{required: required && !field.hide}"
                     ref="inputRef"
                     @place_changed="input"
                     @input.native="input"
  />
</template>

<script>
import { ref, nextTick } from 'vue';

export default {
  props: {
    value: {
      type: String,
      required: false
    },
    field: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const inputRef = ref()

    const input = () => {
      nextTick(() => {
        emit('input', inputRef.value.$el.value)
        nextTick(() => {
          emit('validate')
        })
      })
    }

    return {
      inputRef,
      input,
    }
  }
}
</script>



// WEBPACK FOOTER //
// AddressRender.vue?2c443790